const styles = `:host {
  --gradient: rgba(37, 40, 45, 0) 0%, rgba(37, 40, 45, 0.1) 50%, rgba(37, 40, 45, 0) 100%;
  background-color: var(--goto-ui-04);
  display: inline-flex;
  height: var(--goto-skeleton-size, 1.875rem);
  position: relative;
  overflow: hidden;
}
:host::after {
  animation: skeleton-wave 1.6s ease-in-out 0.5s infinite;
  background: var(--goto-skeleton-gradient);
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 500px;
}

@keyframes skeleton-wave {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
:host([size=xxsmall]) {
  --goto-skeleton-size: 1.125rem;
}

:host([size=xsmall]) {
  --goto-skeleton-size: var(--goto-spacing-05);
}

:host([size=small]) {
  --goto-skeleton-size: var(--goto-spacing-06);
}

:host([size=large]) {
  --goto-skeleton-size: 2.25rem;
}

:host([size=xlarge]) {
  --goto-skeleton-size: var(--goto-spacing-09);
}

:host([size=xxlarge]) {
  --goto-skeleton-size: var(--goto-spacing-11);
}

:host([size=xxxlarge]) {
  --goto-skeleton-size: 5rem;
}

:host([variant=square]),
:host([variant=rectangle]) {
  border-radius: 4px;
}

:host([variant=square]),
:host([variant=circle]) {
  width: var(--goto-skeleton-size, 1.875rem);
}

:host([variant=circle]) {
  border-radius: 50%;
}

:host([variant=rectangle]) {
  min-width: var(--goto-skeleton-size, 1.875rem);
}`; export default styles;